const TypingIndicator = ({
  logo,
}) => {
  return (
    <div className='typing-row'>
      <img src={logo} alt='AI' className='msg-avatar' />
      <div className='typing-bub'>
        <span />
        <span />
        <span />
      </div>
    </div>
  )
}

export default TypingIndicator